import { render, staticRenderFns } from "./ModalProducto.vue?vue&type=template&id=620bd45f&scoped=true&"
import script from "./ModalProducto.vue?vue&type=script&lang=js&"
export * from "./ModalProducto.vue?vue&type=script&lang=js&"
import style0 from "./ModalProducto.vue?vue&type=style&index=0&id=620bd45f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620bd45f",
  null
  
)

export default component.exports